
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creators/[recordId]",
      function () {
        return require("private-next-pages/creators/[recordId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creators/[recordId]"])
      });
    }
  